import { InvoiceForwardingMode } from 'gen/ApiClient';
import { IStrings } from 'localization/IStrings';

export const createInvoiceForwardingModeRecord = (strings: IStrings): Record<InvoiceForwardingMode, string> => {
	return {
		OnDocumentCreated: strings.forwardInvoiceAfterDocumentIsCreated,
		OnInvoiceCreated: strings.forwardInvoiceOnceItsCreatedEvenWithoutDocument,
	};
};
